import styled from 'styled-components';

import BaseInput from '../BaseInput/BaseInput';
import { InputWrapper } from '../Common.styled';

interface StyledBaseInputProps {
  $hasDashedBorder: boolean;
}

export const StyledBaseInput = styled(BaseInput)<StyledBaseInputProps>(
  ({ theme: { color }, $hasDashedBorder }) => {
    if ($hasDashedBorder) {
      return {
        [InputWrapper]: {
          borderStyle: 'dashed',
          borderColor: color.border.primary.default(),
        },
      };
    }

    return {};
  },
);
